import GLightbox from "glightbox";
import 'glightbox/dist/css/glightbox.min.css';
export default class Lightbox {

  constructor() {
    const lightbox = GLightbox({
      zoomable: false,
      moreLength: 0, //0 = no limit on description
      height: '100vh',
      width: '100vw',
      svg: {
        close: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="90" viewBox="0 0 32 32" xml:space="preserve"><path stroke="currentColor" fill="none" stroke-linecap="round" d="M 2,2 L 30,30 M 30,2 L 2,30"/></svg>',
        next:  '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="90" viewbox="0 0 32 32" xml:space="preserve"><path stroke="currentColor" fill="none" stroke-linecap="round" d="M 10,2 l 14 14 l -14 14"/></svg>',
        prev:  '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="90" viewbox="0 0 32 32" xml:space="preserve" style="transform:scale(-1,1);"><path stroke="currentColor" fill="none" stroke-linecap="round" d="M 10,2 l 14 14 l -14 14"/></svg>',
      }
    });
  }
}